// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 聊天室案例操作列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
# **接口权限** 
 接口需要用户对应服务的权限，curl请求示例： 
  ```
  curl -X GET --header accept: application/json http://localhost:8107/stock/case/chat/deal/list?roomId=roomId
  ```
 GET /stock/case/chat/deal/list */
export async function stockCaseChatDealListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseChatDealListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseNewsResp>('/stock/case/chat/deal/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 聊天室案例列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
# **接口权限** 
 接口需要用户对应服务的权限，curl请求示例： 
  ```
  curl -X GET --header accept: application/json http://localhost:8107/stock/case/chat/list?roomId=roomId
  ```
 GET /stock/case/chat/list */
export async function stockCaseChatListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseChatListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseNewsResp>('/stock/case/chat/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池-案例列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /stock/case/list */
export async function stockCaseListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseDetailResp>('/stock/case/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票最新动态 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /stock/case/news */
export async function stockCaseNewsUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseNewsUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseNewsResp>('/stock/case/news', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
